// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/cssWithMappingToString.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".swal2-container .swal2-popup .swal2-actions button.btn-label{padding-left:44px}", "",{"version":3,"sources":["webpack://./resources/js/plugins/sweet-alert/sweet-alert-popup.css"],"names":[],"mappings":"AAAA,8DACI,iBACJ","sourcesContent":[".swal2-container .swal2-popup .swal2-actions button.btn-label {\n    padding-left: 44px;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
